export default "__VITE_ASSET__BFYBbdj2__"